<template>
  <div class="w-full flex flex-col gap-y-2 h-[70vh]">
    <HeaderTypo
      v-if="step == 'NewRegisterForGCCOrVisaHolder'"
      as="h3"
      class="border-b text-2xl border-brand-gray-300"
    >
      {{ $t('NewRegisterForGCCOrVisaHolder') }}
    </HeaderTypo>
    <HeaderTypo v-else as="h3" class="border-b text-2xl border-brand-gray-300">
      {{ $t('register') }}
    </HeaderTypo>

    <div class="flex-1">
      <OboardingFork1
        v-if="step == 'EmirateIdentityQuestion'"
        @onStep1Answer="handleStep1Answer"
      ></OboardingFork1>
      <OboardingFork2
        v-if="step == 'NewRegisterForGCCOrVisaHolder'"
        @onStep1Answer="handleStep2Answer"
      ></OboardingFork2>
    </div>
    <div v-if="step == 'NewRegisterForGCCOrVisaHolder'" class="flex">
      <button
        class="rounded-md bg-gray-400/80 hover:bg-gray-400 px-3 py-1.5"
        @click="step = 'EmirateIdentityQuestion'"
      >
        <div class="w-full flex items-center gap-x-2">
          <faChevronLeft class="w-2 fill-white" />
          <span class="ltr:font-sans tracking-wide flex-1 text-white text-sm pb-[1px]">
            {{ $t('Back') }}
          </span>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
import OboardingFork1 from '@/views/individuals/onboarding/fork1.vue'
import OboardingFork2 from '@/views/individuals/onboarding/fork2.vue'
import faChevronLeft from '@/assets/icons/faChevronLeft.svg?component'
// import OboardingStep2Yes from '@/views/individuals/onboarding/step2__yes.vue'
// import OboardingStep2No from '@/views/individuals/onboarding/step2__no.vue'
// import { useOnboardingStore } from '@/stores/onboarding.js'
// import { onMounted } from 'vue'
import { ref, watch } from 'vue'
import router from '@/router'

const step = ref('EmirateIdentityQuestion')
const modal = ref(null)

watch(modal, (newValue) => {
  if (newValue === false) {
    document.body.style.overflow = 'inherit'
    router.replace('/')
  }
})

// const onboardingStore = useOnboardingStore()

// onMounted(() => {
//   if (!onboardingStore.activeStep) {
//     onboardingStore.activeStep = OboardingStep1
//   }
// })

const handleStep1Answer = (answer) => {
  if (answer) {
    return router.push({ name: 'RegisterIndividualsEid' })
  }

  step.value = 'NewRegisterForGCCOrVisaHolder'
}

const handleStep2Answer = (answer) => {}
</script>

<style lang="scss" scoped></style>
